import * as api from '@/api/about'
import cookie from 'js-cookie'
import { about } from '@/store/mutation-type'

const state = {
    info: {},
    linkList: [],
    quesList: []
}

const getters = {
    [about.CLIENT_INFO]: (state) => {
        let version = '0.0.0'
        let logoUrl = ''
        if (state.info['APP'] === 'MATH_STUDENT') {
            // version = '悠数学 V ' + state.info['_VERSION']
            version = state.info['_VERSION']
            logoUrl = require('@/assets/img/logo-m.png')
        } else {
            // version = '悠数学（老师）V ' + state.info['_VERSION']
            version = state.info['_VERSION']
            logoUrl = require('@/assets/img/logo-qr.png')
        }
        return {
            version: version,
            logoUrl: logoUrl
        }
    },
    [about.LINK_LIST]: (state) => {
        return (state.linkList[state.info['APP']] || [])[state.info['DEVICE_TYPE']]
    },
    [about.QUES_LIST]: (state) => {
        return state.quesList[state.info['APP']]
    }
}

const actions = {
    [about.CLIENT_INFO]: ({ commit }) => {
        commit(about.CLIENT_INFO, cookie.get())
    },
    [about.LINK_LIST]: ({ commit }) => {
        api.linkData({}, (_data) => commit(about.LINK_LIST, _data))
    },
    [about.QUES_LIST]: ({ commit }) => {
        api.quesData({}, (_data) => commit(about.QUES_LIST, _data))
    }
}

const mutations = {
    [about.LINK_LIST]: function (state, _data) {
        state.linkList = _data
    },
    [about.QUES_LIST]: function (state, _data) {
        state.quesList = _data
    },
    [about.CLIENT_INFO]: function (state, _data) {
        state.info = _data
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/about.js